import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import FeeManagement from './FeeManagement'; // Your existing component
import OtherFeeManagement from './OtherFeeManagement'; // New component you'll create

const StudentFeeTabs = () => {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Box p={2}>
      <Tabs value={tabIndex} onChange={(_, newVal) => setTabIndex(newVal)}>
        <Tab label="Student Fee List" />
        <Tab label="Miscellaneous Fee List" />
      </Tabs>

      {tabIndex === 0 && (
        <Box mt={2}>
          <FeeManagement />
        </Box>
      )}
      {tabIndex === 1 && (
        <Box mt={2}>
          <OtherFeeManagement />
        </Box>
      )}
    </Box>
  );
};

export default StudentFeeTabs;
